import { Helmet } from "react-helmet-async";
import { ContactEmails } from "components/common/ContactEmails";
import { CTASection } from "components/cta-section";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "components/ui/accordion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import { Input } from "components/ui/input";
import { Search } from "lucide-react";
import { faqCategories } from "content/faqContent";

export default function FAQPage() {
  return (
    <>
      <Helmet>
        <title>FAQ | Fortify</title>
        <meta
          name="description"
          content="Find answers to frequently asked questions about equity crowdfunding on Fortify."
        />
      </Helmet>

      <section className="py-16 bg-secondary/30">
        <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight">
            Frequently Asked Questions
          </h1>
          <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">
            Find answers to common questions about investing and raising capital on Fortify.
          </p>

          <div className="max-w-md mx-auto mt-8 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input placeholder="Search for answers..." className="pl-10" />
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
          <Tabs defaultValue="general" className="max-w-4xl mx-auto">
            <TabsList className="w-full flex-wrap justify-start h-auto gap-2 mb-8">
              {Object.entries(faqCategories).map(([key, category]) => (
                <TabsTrigger key={key} value={key} className="flex-shrink-0">
                  {category.title}
                </TabsTrigger>
              ))}
            </TabsList>

            {Object.entries(faqCategories).map(([key, category]) => (
              <TabsContent key={key} value={key}>
                <Accordion type="single" collapsible className="w-full">
                  {category.questions.map((faq, index) => (
                    <AccordionItem key={faq.question} value={`item-${index}`}>
                      <AccordionTrigger className="text-left">
                        {faq.question}
                      </AccordionTrigger>
                      <AccordionContent className="text-muted-foreground">
                        {faq.answer}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </section>

      <section className="py-16 bg-secondary/30">
        <div className="container mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 text-center">
          <h2 className="text-2xl font-bold mb-4">Still have questions?</h2>
          <p className="text-muted-foreground mb-6 max-w-lg mx-auto">
            Our team is here to help. Reach out using the contact below and we&apos;ll get back to
            you within 24 hours.
          </p>
          <ContactEmails className="max-w-md mx-auto text-left" />
        </div>
      </section>

      <CTASection />
    </>
  );
}
